import React from 'react';
import { Routes as NativeRoutes, Route, Navigate } from 'react-router-dom';
import { useRouter } from './lib';
import { EAuthorization_Features } from '@shared/api';
import { useOpenIdContext } from '@entities/OpenIDProvider/OpenIdContext';
import UserDetails from '@widgets/UserManagementTable/components/UserManagementViewDrawer/components/UserDetails/UserDetails';
import LoginWizard from '@pages/LoginWizard';
import Preferences from '@pages/Preferences';
import MyPortfolioPage from '@pages/MyPortfolioPage';
import RIADashboardPage from '@pages/RIADashboard';
import TradeOrderForm from '@pages/TradeOrderForm';

export const Routes: React.FC = () => {
    const { router } = useRouter();

    const { roles } = useOpenIdContext();

    return (
        <NativeRoutes>
            {router.map((routerItem) => {
                const RenderedComponent = routerItem.Component;
                return (
                    <Route
                        key={routerItem.path}
                        path={routerItem.path}
                        element={<RenderedComponent />}
                    />
                );
            })}
            <Route
                path='*'
                element={
                    <Navigate
                        to={roles?.includes(EAuthorization_Features.TradeDesk) ? '/tradeorders' : '/dashboard'}
                        replace
                    />
                }
            />
            <Route
                path='/LoginWizard'
                element={<LoginWizard />}
            />
            {roles?.includes(EAuthorization_Features.ClearingUser) && (
                <Route
                    path='/detail/:fdid'
                    element={<UserDetails />}
                />
            )}
            {roles?.includes(EAuthorization_Features.ClearingUser) && (
                <Route
                    path='/riadashboard/:id?'
                    element={<RIADashboardPage />}
                />
            )}
            {roles?.includes(EAuthorization_Features.RIA) && (
                <Route
                    path='/preferences/:userId'
                    element={<Preferences />}
                />
            )}
            {roles?.includes(EAuthorization_Features.TradeDesk) && (
                <Route
                    path='/trade-details/:orderId'
                    element={<TradeOrderForm />}
                />
            )}
            {roles?.includes(EAuthorization_Features.Client) && (
                <Route
                    path='/my-portfolio'
                    element={<MyPortfolioPage />}
                />
            )}
            {!roles?.includes(EAuthorization_Features.TradeDesk) && (
                <Route
                    path=''
                    element={
                        <Navigate
                            to='/dashboard'
                            replace
                        />
                    }
                />
            )}
            {roles?.includes(EAuthorization_Features.TradeDesk) && (
                <Route
                    path=''
                    element={
                        <Navigate
                            to='/tradeorders'
                            replace
                        />
                    }
                />
            )}
        </NativeRoutes>
    );
};
